var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-button",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){$event.stopPropagation();return _vm.click.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }